var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "actions is-centered" },
    [
      _c("div", { staticClass: "modal", class: { "is-active": _vm.modal } }, [
        _c("div", { staticClass: "modal-background" }),
        _c("div", { staticClass: "modal-content is-flex is-centered" }, [
          _c("div", { staticClass: "box is-centered confirmation" }, [
            _c("div", { staticClass: "field" }, [
              _vm._m(0),
              _c("div", { staticClass: "control is-centered" }, [
                _c("div", { staticClass: "field is-grouped" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-success",
                        class: { "is-loading": _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.cancelById }
                      },
                      [
                        _c("b-icon", {
                          attrs: { size: "is-small", icon: "check" }
                        }),
                        _c("span", [
                          _vm._v("\n                    Sí\n                  ")
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-danger",
                        class: { "is-loading": _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.onCloseModal }
                      },
                      [
                        _c("b-icon", {
                          attrs: { size: "is-small", icon: "close" }
                        }),
                        _c("span", [
                          _vm._v("\n                    No\n                  ")
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _c("button", {
          staticClass: "modal-close is-large",
          attrs: { "aria-label": "close" },
          on: { click: _vm.onCloseModal }
        })
      ]),
      _c(
        "AppRadialMenu",
        {
          attrs: {
            size: 36,
            "item-size": 48,
            radius: 95,
            "angle-restriction": 180,
            rotate: 270
          }
        },
        [
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-primary has-background-primary has-text-white",
              attrs: { "data-tooltip": "Detalle de recibo electrónico de pago" }
            },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "action-option",
                  attrs: { to: { name: "RepDetail", params: { uuid: _vm.id } } }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "eye" }
                  })
                ],
                1
              )
            ],
            1
          ),
          ![201, 202].includes(_vm.invoice.operation.status)
            ? _c(
                "AppRadialMenuItem",
                {
                  staticClass:
                    "tooltip is-tooltip-success has-background-success has-text-white",
                  attrs: { "data-tooltip": "Reenviar XML y PDF" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "action-option",
                      on: { click: _vm.sendEmail }
                    },
                    [
                      _c("BIcon", {
                        staticClass: "action-option-icon",
                        attrs: { icon: "send" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          ![201, 202].includes(_vm.invoice.operation.status) &&
          !_vm.showUpdateCfdiStatus(_vm.invoice)
            ? _c(
                "AppRadialMenuItem",
                {
                  staticClass:
                    "tooltip is-tooltip-danger has-background-danger has-text-white",
                  attrs: {
                    "data-tooltip": "Cancelar recibo electrónico de pago"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "action-option",
                      on: { click: _vm.cancelInvoice }
                    },
                    [
                      _c("BIcon", {
                        staticClass: "action-option-icon",
                        attrs: { icon: "cancel" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.showUpdateCfdiStatus(_vm.invoice)
            ? _c(
                "AppRadialMenuItem",
                {
                  staticClass:
                    "tooltip is-tooltip-danger has-background-danger has-text-white",
                  attrs: { "data-tooltip": "Actualizar Estado CFDI" }
                },
                [_c("UpdateCfdiStatus", { attrs: { invoice: _vm.invoice } })],
                1
              )
            : _vm._e(),
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-info has-background-info has-text-white",
              attrs: { "data-tooltip": "Descargar XML" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "action-option",
                  on: {
                    click: function($event) {
                      return _vm.download("xml")
                    }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "cloud-download" }
                  }),
                  _c("span", { staticClass: "close-label" }, [
                    _vm._v("\n          xml\n        ")
                  ])
                ],
                1
              )
            ]
          ),
          ![201, 202].includes(_vm.invoice.operation.status)
            ? _c(
                "AppRadialMenuItem",
                {
                  staticClass:
                    "tooltip is-tooltip-info has-background-info has-text-white",
                  attrs: { "data-tooltip": "Descargar PDF" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "action-option",
                      on: {
                        click: function($event) {
                          return _vm.download("pdf")
                        }
                      }
                    },
                    [
                      _c("BIcon", {
                        staticClass: "action-option-icon",
                        attrs: { icon: "cloud-download" }
                      }),
                      _c("span", { staticClass: "close-label" }, [
                        _vm._v("\n          pdf\n        ")
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          ![201, 202].includes(_vm.invoice.operation.status)
            ? _c(
                "AppRadialMenuItem",
                {
                  staticClass:
                    "tooltip is-tooltip-success has-background-success has-text-white",
                  attrs: { "data-tooltip": "Regenerar PDF" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "action-option",
                      on: {
                        click: function($event) {
                          return _vm.regeneratePdf("pdf", _vm.invoice)
                        }
                      }
                    },
                    [
                      _c("BIcon", {
                        staticClass: "action-option-icon",
                        attrs: { icon: "autorenew" }
                      }),
                      _c("span", { staticClass: "close-label" }, [
                        _vm._v("\n          pdf\n        ")
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v(
        "\n            ¿Estas seguro de cancelar este recibo electrónico de pago?\n            "
      ),
      _c("br"),
      _vm._v(
        "\n            ¿Para cancelar un pago es necesario generar su reemplazo, deseas continuar?\n          "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }